'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = require('../utils/errors'),
    ArityMismatchError = _require.ArityMismatchError;

var Context = function () {
  function Context() {
    _classCallCheck(this, Context);
  }

  _createClass(Context, [{
    key: 'otherwise',
    value: function otherwise() {
      throw new ArityMismatchError(arguments.length);
    }
  }]);

  return Context;
}();

var makeOverloaded = function makeOverloaded(context, fns) {
  var onlyFns = fns.filter(function (fn) {
    return typeof fn === 'function';
  });
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var fn = onlyFns.find(function (fn) {
      return fn.length === args.length;
    });
    return fn ? fn.apply(undefined, args) : context.otherwise.apply(context, args);
  };
};

var overload = function overload() {
  for (var _len2 = arguments.length, fns = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  var context = new Context();
  var overloaded = makeOverloaded(context, fns);
  overloaded.orElse = function (fn) {
    context.otherwise = fn;
    return overloaded;
  };
  return overloaded;
};

module.exports = overload;


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/functional/overload.js
// module id = 2172
// module chunks = 37